<!--
 * @Author: zhaoyang
 * @Date: 2020-10-29 10:42:36
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-05 11:14:51
 * @Description: 取消订单
-->
<template>
  <div class="explain-popup">
    <dl class="explain-context">
      <dt>{{$t('components_order_boreder_refound_explain_642')}}</dt>
      <dd>
        <span>1.</span
        >{{$t('components_order_boreder_refound_explain_643')}}</dd>
      <dd><span>2.</span>{{$t('components_order_boreder_refound_explain_644')}}</dd>
      <dd>
        <span>3.</span
        >{{$t('components_order_boreder_refound_explain_645')}}</dd>
      <dd><span>4.</span>{{$t('components_order_boreder_refound_explain_646')}}</dd>
      <dd><span>5.</span>{{$t('components_order_boreder_refound_explain_647')}}</dd>
    </dl>
    <div class="refound-footer">
      <div class="refound-submit" @click="handleOrderRound">{{$t('components_order_oreder_refound_explain_641')}}</div>
    </div>
  </div>
</template>

<script>
import popupMixin from '@/components/common/popup/general.js';
export default {
  mixins: [popupMixin],
  methods: {
    handleOrderRound() {
      this.$emit('handleRoundExplain', 'borderRound');
    },
  },
};
</script>

<style lang="scss" scoped>
.refound-footer {
  width: 375px;
  bottom: 0;
  left: 0;
  padding: 0 16px 30px;
  position: absolute;
}
.explain-popup {
  max-height: 550px;
  overflow: hidden;
  border-radius: 16px 16px 0 0;
}
.explain-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 63px;
  padding: 0 20px;
  border-bottom: 1px solid #e8eaee;
  font-weight: 500;
  font-size: 18px;
}
.close-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  font-weight: 900;
  background: rgba(249, 249, 249, 0.78);
  color: rgba(0, 0, 0, 0.3);
}
.explain-context {
  padding: 0 20px 60px;
  font-size: 14px;
  line-height: 20px;
  color: #222c43;
  dt {
    margin-bottom: 8px;
    font-weight: 600;
  }
  dd {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    margin-bottom: 16px;
    span {
      margin-right: 6px;
    }
  }
}
.refound-submit {
  width: 100%;
  height: 48px;
  text-align: center;
  line-height: 48px;
  font-weight: 500;
  font-size: 16px;
  border-radius: 25px;
  @include button-yellow;
  font-weight: 400;
}
</style>
